import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

import { OrderItemType } from '../artistOrderApi'

export enum CouponDiscountType {
  Percentage = 'percentage',
  Fixed = 'fixed',
}

export const CHECKOUT_HIGHLIGHTED_OFFER_TYPE = 'checkout_highlighted'

export type OfferedCoupon = {
  code: string
  discountType: CouponDiscountType
  discount: number
  minSpend: number
  targetOrderItemTypes: OrderItemType[] | null
  endDate: string | null
  offerType: string
}

type GetOfferedCouponsResponse = {
  coupons: OfferedCoupon[]
}

const artistCouponsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getOfferedCoupons: build.query<GetOfferedCouponsResponse, void>({
      query: () => ({
        url: `${APP.TIKTOK_SERVER}/artist/coupons`,
        params: { offerType: CHECKOUT_HIGHLIGHTED_OFFER_TYPE },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useGetOfferedCouponsQuery } = artistCouponsApi
